import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {IRegistrationWizardGateVariants, useRegistrationWizardGateDecision} from "../../hooks/use_registration_wizard_gate_decision";
import {useRunRegistrationFlowControlAction} from "../../hooks/use_run_registration_flow_control_action";
import {applyRegistrationFlowVariant, closeFlow, isRegistrationWizardStep, UnlockChoiceDecision} from "../../state/registration_flow_slice";
import {UnlockChoiceEntryPoint} from "../../types/UnlockChoiceEntryPoint";
import {getRegistrationFlowUserState} from "../../utils/get_registration_flow_user_state";
import {isUnlockChoiceEligible} from "../../utils/is_unlock_choice_eligible";

export const RegistrationWizardGate = () => {
    const dispatch = useAppDispatch();
    const {controlAction, currentStep, wizardEntry, unlockChoiceEntryPoint, unlockChoiceOrigin, propertyId, offerId} = useAppSelector(
        (state) => state.registrationFlow
    );
    const {data: userProfile} = useGetUserProfileQuery();
    const runControlAction = useRunRegistrationFlowControlAction();
    const isLeavingPageOnControl = controlAction?.type === "km_login";
    const needsWizard = isRegistrationWizardStep(currentStep);
    const needsChoice =
        controlAction !== null &&
        unlockChoiceOrigin === "cta" &&
        unlockChoiceEntryPoint !== undefined &&
        isUnlockChoiceEligible(unlockChoiceEntryPoint, {propertyId, offerId});
    const isPropertyLeadChoice = needsChoice && wizardEntry === UnlockChoiceEntryPoint.LEAD;
    const isExtendedChoice = needsChoice && !isPropertyLeadChoice;

    const isFlowShown = ({isWizard, isChoice}: IRegistrationWizardGateVariants) => (needsWizard && isWizard) || isChoice;

    useRegistrationWizardGateDecision({
        readsWizard: needsWizard || isExtendedChoice,
        isChoiceInScope: (isWizard) => isPropertyLeadChoice || (isExtendedChoice && isWizard),
        getExposureOptions: (variants) => ({isLeavingPage: isLeavingPageOnControl && !isFlowShown(variants)}),
        onDecide: ({isWizard, isChoice, exposureTracking}) => {
            const user = getRegistrationFlowUserState(userProfile);

            if (needsWizard && isWizard) {
                const unlockChoiceDecision: UnlockChoiceDecision | null = needsChoice ? (isChoice ? "treatment" : "control") : null;
                dispatch(applyRegistrationFlowVariant({variant: "wizard", user, unlockChoiceDecision}));
                return;
            }

            if (isChoice) {
                dispatch(applyRegistrationFlowVariant({variant: needsWizard ? "legacy" : "wizard", user, unlockChoiceDecision: "treatment"}));
                return;
            }

            if (controlAction) {
                dispatch(closeFlow());

                if (isLeavingPageOnControl && exposureTracking) {
                    void exposureTracking.catch(() => undefined).then(() => runControlAction(controlAction));
                    return;
                }

                runControlAction(controlAction);
                return;
            }

            dispatch(applyRegistrationFlowVariant({variant: "legacy", user}));
        }
    });

    return null;
};
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {IRegistrationWizardGateVariants, useRegistrationWizardGateDecision} from "../../hooks/use_registration_wizard_gate_decision";
import {useRunRegistrationFlowControlAction} from "../../hooks/use_run_registration_flow_control_action";
import {applyRegistrationFlowVariant, closeFlow, isRegistrationWizardStep, UnlockChoiceDecision} from "../../state/registration_flow_slice";
import {UnlockChoiceEntryPoint} from "../../types/UnlockChoiceEntryPoint";
import {getRegistrationFlowUserState} from "../../utils/get_registration_flow_user_state";
import {isUnlockChoiceEligible} from "../../utils/is_unlock_choice_eligible";

export const RegistrationWizardGate = () => {
    const dispatch = useAppDispatch();
    const {controlAction, currentStep, wizardEntry, unlockChoiceEntryPoint, unlockChoiceOrigin, propertyId, offerId} = useAppSelector(
        (state) => state.registrationFlow
    );
    const {data: userProfile} = useGetUserProfileQuery();
    const runControlAction = useRunRegistrationFlowControlAction();
    const isLeavingPageOnControl = controlAction?.type === "km_login";
    const needsWizard = isRegistrationWizardStep(currentStep);
    const needsChoice =
        controlAction !== null &&
        unlockChoiceOrigin === "cta" &&
        unlockChoiceEntryPoint !== undefined &&
        isUnlockChoiceEligible(unlockChoiceEntryPoint, {propertyId, offerId});
    const isPropertyLeadChoice = needsChoice && wizardEntry === UnlockChoiceEntryPoint.LEAD;
    const isExtendedChoice = needsChoice && !isPropertyLeadChoice;

    const isFlowShown = ({isWizard, isChoice}: IRegistrationWizardGateVariants) => (needsWizard && isWizard) || isChoice;

    useRegistrationWizardGateDecision({
        readsWizard: needsWizard || isExtendedChoice,
        isChoiceInScope: (isWizard) => isPropertyLeadChoice || (isExtendedChoice && isWizard),
        getExposureOptions: (variants) => ({isLeavingPage: isLeavingPageOnControl && !isFlowShown(variants)}),
        onDecide: ({isWizard, isChoice, exposureTracking}) => {
            const user = getRegistrationFlowUserState(userProfile);

            if (needsWizard && isWizard) {
                const unlockChoiceDecision: UnlockChoiceDecision | null = needsChoice ? (isChoice ? "treatment" : "control") : null;
                dispatch(applyRegistrationFlowVariant({variant: "wizard", user, unlockChoiceDecision}));
                return;
            }

            if (isChoice) {
                dispatch(applyRegistrationFlowVariant({variant: needsWizard ? "legacy" : "wizard", user, unlockChoiceDecision: "treatment"}));
                return;
            }

            if (controlAction) {
                dispatch(closeFlow());

                if (isLeavingPageOnControl && exposureTracking) {
                    void exposureTracking.catch(() => undefined).then(() => runControlAction(controlAction));
                    return;
                }

                runControlAction(controlAction);
                return;
            }

            dispatch(applyRegistrationFlowVariant({variant: "legacy", user}));
        }
    });

    return null;
};
